import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.778 20.01H2.222V5.24c0-.68.547-1.23 1.222-1.23h17.112c.675 0 1.222.55 1.222 1.23z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "18.5",
      cy: "9.51",
      r: "1.5",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M23.75 20.01a.75.75 0 0 1-.75.75H1a.75.75 0 0 1 0-1.5h.472V5.24c0-1.089.878-1.98 1.972-1.98h17.112c1.094 0 1.972.891 1.972 1.98v14.02H23a.75.75 0 0 1 .75.75m-2.722-.75V5.24c0-.27-.217-.48-.472-.48H3.444a.477.477 0 0 0-.472.48v14.02z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m15.79 12.51-2.576 2.577-3.667-3.693-5.115 5.116"
    }, null, -1)
  ])))
}
export default { render: render }